<template>
  <v-col cols="12" sm="12" md="6" class="m-0 p-0">
    <v-row>
      <!--   <v-col cols="12" sm="12" md="12" class="mb-0 pb-0">
        <h5>Plage de date</h5>
      </v-col> -->
      <v-col cols="12" sm="12" md="6" class="pt-0">
        <h6 class="col-12 mb-0 pb-2">Date de début</h6>
        <div class="col-12 mt-0 pt-0">
          <v-menu
            ref="startMenu"
            v-model="startMenu"
            :close-on-content-click="false"
            :return-value.sync="dateRange.start"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRange.start"
                label="Choisir la date de début"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                small
                :rules="dateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateRange.start"
              no-title
              scrollable
              :max="dateRange.end"
            >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="startMenu = false"
                >Annuler</v-btn
              >
              <v-btn
                color="primary"
                @click="$refs.startMenu.save(dateRange.start)"
                >Continuer</v-btn
              >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>

      <v-col cols="12" sm="12" md="6" class="pt-0">
        <h6 class="col-12 mb-0 pb-2">Date de fin</h6>
        <div class="col-12 mt-0 pt-0">
          <v-menu
            ref="endMenu"
            v-model="endMenu"
            :close-on-content-click="false"
            :return-value.sync="dateRange.end"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateRange.end"
                label="Choisir la date de fin"
                append-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                small
                :rules="dateRules"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateRange.end"
              no-title
              scrollable
              :min="dateRange.start"
            >
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="endMenu = false">Annuler</v-btn>
              <v-btn color="primary" @click="$refs.endMenu.save(dateRange.end)"
                >Continuer</v-btn
              >
            </v-date-picker>
          </v-menu>
        </div>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
export default {
  name: "DateRangePicker",
  data: () => ({
    dateRange: {
      start: null,
      end: null,
    },
    startMenu: false,
    endMenu: false,
    dateRules: [(v) => !!v || "Date is required"],
  }),
  methods: {
    resetDate (){
      this.dateRange = {
      start: null,
      end: null,
    }
    },
  },
  watch: {
    dateRange: {
      handler(newRange) {
        this.$emit("update:dateRange", newRange);
      },
      deep: true,
    },
  },
};
</script>
